import React from 'react';
import { CheckmarkIcon } from '../svg/CheckmarkIcon';

type Props = {
    feature: FeatureListItem;
};

export type FeatureListItem = {
    label: string;
    description: string;
    free: {
        name: string;
        included: boolean;
    };
    tier1?: {
        name: string;
        included: boolean;
    };
    tier2?: {
        name: string;
        included: boolean;
    };
    tier3?: {
        name: string;
        included: boolean;
    };
    comingSoon?: boolean;
};

export const FeatureListItem: React.FC<Props> = ({ feature }) => {
    const isHeader =
        !feature.free.included &&
        !feature.tier1?.included &&
        !(feature.tier2 && feature.tier2.included) &&
        !(feature.tier3 && feature.tier3.included);

    return (
        <div className={`feature-list-item${isHeader ? ' header' : ''}`}>
            <div className="item-info-container">
                <h2 className="item-label">{feature.label}</h2>
                {feature.description && <p className="item-description">{feature.description}</p>}
            </div>
            <div className="checkmark-container free">{feature.free.included && <CheckmarkIcon />}</div>
            <div className="checkmark-container premium blue-background">
                {feature.tier1?.included && <CheckmarkIcon />}
            </div>
            {feature.tier2?.included && (
                <div className="checkmark-container premium green-background">{feature.tier2 && <CheckmarkIcon />}</div>
            )}
            {!feature.tier2?.included && feature.tier3?.included && <div></div>}
            {feature.tier3?.included && (
                <div className="checkmark-container premium purple-background">
                    {feature.tier3 && <CheckmarkIcon />}
                </div>
            )}
        </div>
    );
};
